import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";

const token = localStorage.getItem('authToken');

class EditBottomBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: null,
      title: "",
      userName: "",
      pincode: "",
      city: "",
      packageTitle: "",
      packageId: "",
      packageAmount: "",
      submissionStatus: null,
      currentImageUrl: null,
      errors: [],
      url: "",
      category: '',
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      id: null,
      isLoading: true,
      imageUrl: "",
      packages: [],
      showModal: false,
      selectedCategoryId: null,
      showModalReject: false,
      selectedCategoryIdReject: null,
      startDate: "", // New state for start date
      expiryDate: "", // New state for expiry date
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
      await this.fetchPackages();
    } else {
      console.error("No match params found.");
    }
  }

  fetchData = async (id) => {
    console.log("Fetching data for ID:", id);
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/sponsor/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response) {
        console.log(response.data.data);
  
        const { title, pincode, city, package: packageInfo, image, startDate, expiryDate,url } = response.data.data;
        
        // Check and log the date values
        console.log("Start Date from API:", startDate);
        console.log("Expiry Date from API:", expiryDate);
  
        this.setState({
          title: title || "",
          pincode: pincode || "",
          city: city || "",
          url: url || "",
          packageTitle: packageInfo?.title || "",
          packageId: packageInfo?._id || "",
          packageAmount: packageInfo?.amount || "",
          imageUrl: image || "",
          currentImageUrl: image ? `https://uma-classees.blr1.digitaloceanspaces.com/${image}` : "",
          startDate: startDate ? new Date(startDate).toISOString().split('T')[0] : "", // Format date for input
          expiryDate: expiryDate ? new Date(expiryDate).toISOString().split('T')[0] : "", // Format date for input
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  };
  

  fetchPackages = async () => {
    try {
      const response = await axios.get('https://samaj.aasmo.in/api/admin/packages', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        this.setState({ packages: response?.data?.data });
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

 
  handleApprove = (id) => {
    this.setState({ selectedCategoryId: id, showModal: true });
  };
  handleReject= (id) => {
    this.setState({ selectedCategoryIdReject: id, showModalReject: true });
  };
  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];
  
    files.forEach((file) => {
      // Check file size
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
        this.setState({ errors });
        return;
      }
  
      // Check image dimensions
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          if (img.width !== 1500 || img.height !== 300) {
            errors.push(`${file.name} has incorrect dimensions. Please upload an image with dimensions 1500x300 pixels.`);
          } else {
            this.setState({
              textInput: file,
              currentImageUrl: URL.createObjectURL(file),
            });
          }
          this.setState({ errors });
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  handleUpdate = async (e) => {
    const { id } = this.props.match.params;

    try {
    
      const formData = new FormData();
      formData.append('status', 'approved');

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/sponsor/${id}`, formData,{
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
     console.log(response.data)
      if (response.status === 200) {
        this.setState({ showModal: false })}
    
      
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  handleUpdateReject= async (e) => {
    const { id } = this.props.match.params;

    try {
    
      const formData = new FormData();
      formData.append('status', 'no');

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/sponsor/${id}`, formData,{
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
     console.log(response.data)
      if (response.status === 200) {
        this.setState({ showModalReject: false })}
    
      
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };



  

  handleChangePackage = (e) => {
    const selectedPackageId = e.target.value;
    const selectedPackage = this.state.packages.find(pkg => pkg._id === selectedPackageId);

    this.setState({
      packageId: selectedPackageId,
      packageTitle: selectedPackage?.title || "",
      packageAmount: selectedPackage?.amount || ""
    });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
    this.setState({ submeet: true });

    const { textInput, packageId, pincode, title, city, startDate, expiryDate ,url} = this.state;

    try {
      const formData = new FormData();
      if (textInput) {
        formData.append("image", textInput);
      } else {
        formData.append("image", this.state.imageUrl);
      }

      formData.append("title", title);
      formData.append("pincode", pincode);
      formData.append("city", city);
      formData.append("package", packageId);
      formData.append("startDate", startDate); // Append start date
      formData.append("expiryDate", expiryDate); // Append expiry date
      formData.append("url", url); // Append URL
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/sponsor/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push("/sponsor-list");
        }, 2000);
      }

      console.log(response, "==>res");
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { title, userName, pincode, city,url, packageId, packageTitle, showModal, packageAmount, selectedCategoryId, errors, currentImageUrl, showModalReject, submeet, category, submissionStatus, isLoading, packages, startDate, expiryDate } = this.state;
    const isFormValid = title.trim() && userName.trim() && city.trim() && packageTitle.trim() && packageAmount.trim() && startDate.trim() && expiryDate.trim();

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="col-md-12">
        <div className="card">
     
          <div className="header">
            <h2>Edit Sponsors</h2>
          </div>
          <div className="card-body">
            <form onSubmit={this.handleSubmit}>
              {errors.length > 0 && (
                <div className="alert alert-danger">
                  {errors.map((error, index) => (
                    <p key={index}>{error}</p>
                  ))}
                </div>
              )}
              <div className="form-group">
                <label htmlFor="title">Title</label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  name="title"
                  value={title}
                  onChange={(e) => this.setState({ title: e.target.value })}
                />
              </div>
          
              <div className="form-group">
                <label htmlFor="pincode">Pincode</label>
                <input
                  type="text"
                  className="form-control"
                  id="pincode"
                  name="pincode"
                  value={pincode}
                  onChange={(e) => this.setState({ pincode: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label htmlFor="city">City</label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  name="city"
                  value={city}
                  onChange={(e) => this.setState({ city: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label htmlFor="package">Package</label>
                <select
                  className="form-control"
                  id="package"
                  value={packageId}
                  onChange={this.handleChangePackage}
                >
                  <option value="">Select Package</option>
                  {packages.map((pkg) => (
                    <option key={pkg._id} value={pkg._id}>
                      {pkg.title} - {pkg.amount}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>URL</label>
                <input
                  type="url"
                  className="form-control"
                  value={url}
                  name="url"
                  onChange={(e) => this.setState({ url: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label htmlFor="startDate">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  name="startDate"
                  value={startDate}
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="expiryDate">Expiry Date</label>
                <input
                  type="date"
                  className="form-control"
                  id="expiryDate"
                  name="expiryDate"
                  value={expiryDate}
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="image">Image</label>
                <input
                  type="file"
                  className="form-control"
                  id="image"
                  onChange={this.handleChange}
                />
              </div>
              {currentImageUrl && (
                <div className="form-group">
                  <img src={currentImageUrl} alt="Preview" className="img-thumbnail" />
                </div>
              )}
                         <div className="form-group">
          <label>Actions</label><br></br>
          <div className="btn-group">
            <button type="button" className="btn btn-success" 
           onClick={() => this.handleApprove(category.id)}
            >
              Approve
            </button>&nbsp; &nbsp;&nbsp;
            <button type="button" className="btn btn-danger" onClick={() => this.handleReject(category.id)}>
              Reject
            </button>
          </div>
        </div>
               {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
            </form>
          </div>
        </div>
        <ConfirmApprovedModel
          show={showModal}
          handleClose={() => this.setState({ showModal: false })}
          handleConfirm={() => this.handleUpdate(selectedCategoryId)}
        />
         <ConfirmRejectModel
          show={showModalReject}
          handleClose={() => this.setState({ showModalReject: false })}
          handleConfirm={() => this.handleUpdateReject(selectedCategoryId)}
        />
      </div>
    );
  }
}

export default withRouter(connect(null, { notifyGeneralInfo })(EditBottomBanner));
